import { EVENT_SOURCE } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';

type OnLinkedPRsFetchSuccessArgs = {
	issueCount: number;
	prCount: number;
	issuesWithPRsCount: number;
	latencyMs: number;
};

/**
 * Fires when the linked PRs hydration fetch succeeds.
 * Tracks how many issues were queried, how many PRs were returned, and fetch latency.
 */
export const onLinkedPRsFetchSuccess = ({
	issueCount,
	prCount,
	issuesWithPRsCount,
	latencyMs,
}: OnLinkedPRsFetchSuccessArgs): FireAnalyticsEvent => {
	return {
		action: 'taskSuccess',
		actionSubject: 'linkedPRsFetch',
		eventType: 'operational',
		source: EVENT_SOURCE,
		attributes: {
			additionalAttributes: {
				issueCount,
				prCount,
				issuesWithPRsCount,
				latencyMs,
			},
		},
	};
};

type OnLinkedPRsFetchFailArgs = {
	reason: string;
	latencyMs: number;
};

/**
 * Fires when the linked PRs hydration fetch fails.
 * Tracks the failure reason and how long the request took before failing.
 */
export const onLinkedPRsFetchFail = ({
	reason,
	latencyMs,
}: OnLinkedPRsFetchFailArgs): FireAnalyticsEvent => {
	return {
		action: 'taskFail',
		actionSubject: 'linkedPRsFetch',
		eventType: 'operational',
		source: EVENT_SOURCE,
		attributes: {
			additionalAttributes: {
				reason,
				latencyMs,
			},
		},
	};
};
